import { useEffect } from "react";
import CommonRoutes from "./Routes/CommonRoutes";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import AOS from 'aos';
import { useLocation } from "react-router-dom";
import useMeta from "./hooks/useMeta";
import { DynamicMetaTags } from "./components/comman/DynamicMetaTags";

function App() {
  const location = useLocation();

  useEffect(() => {
    AOS.init({
      duration: 400,
      easing: 'ease',
      once: false,
    });

    return () => {
      AOS.refresh();
    };
  }, []);

  const pathToTypeMap = {
    "/": "Home",
    "/blog": "Blog",
    "/contact-us": "Contactus"
  };

  const currentPath = location.pathname;
  const metaType = pathToTypeMap[currentPath] || null;

  const { meta, loading, error } = useMeta(metaType);


  return (
    <>
      <DynamicMetaTags metaString={meta} />
      <CommonRoutes />
      <ToastContainer
        autoClose={2000}
        hideProgressBar
        closeOnClick
        rtl={false}
        theme="light"
        position="top-center"
      />
    </>
  );
}

export default App;
